/* Phone-only wholesale authentication. Tokens remain in this tab's memory. */
(() => {
  'use strict';
  const root=document.querySelector('[data-wella-phone-login]');
  if(!root || root.dataset.initialized) return;
  root.dataset.initialized='true';
  const base=new URL(root.dataset.endpoint,location.origin);
  if(base.origin!==location.origin || !base.pathname.startsWith('/apps/')) return;
  const $=selector=>root.querySelector(selector);
  const browserKey=btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
  let phone='',challengeId='',sessionToken='',nextSend=0,sending=false;
  // Persistent session (30-day sliding, revocable server-side). The token lives in localStorage so a page refresh keeps the customer
  // signed in; every storage access is guarded (private mode / blocked storage -> memory only, the old behaviour).
  const STORAGE_KEY='wella_wholesale_session_v1',TOKEN_RE=/^[A-Za-z0-9_-]{43}$/;
  const store={
    read(){try{const v=window.localStorage.getItem(STORAGE_KEY);return v&&TOKEN_RE.test(v)?v:'';}catch{return '';}},
    write(v){try{window.localStorage.setItem(STORAGE_KEY,v);}catch{/* memory only */}},
    clear(){try{window.localStorage.removeItem(STORAGE_KEY);}catch{/* ignore */}},
  };
  const digits=value=>value.replace(/[٠-٩]/g,c=>String(c.charCodeAt(0)-0x660)).replace(/[۰-۹]/g,c=>String(c.charCodeAt(0)-0x6f0));
  const message=text=>{$('[role="status"]').textContent=text;};
  async function post(operation,body) {
    const response=await fetch(base.pathname.replace(/\/$/,'')+'/'+operation,{method:'POST',credentials:'omit',cache:'no-store',
      headers:{'Content-Type':'text/plain; charset=utf-8'},body:JSON.stringify(body),signal:AbortSignal.timeout(30000)});
    const result=await response.json();
    if(!response.ok){const err=new Error(result.message||'تعذر الاتصال. حاول تاني.');err.code=result.code;if(result.quote&&typeof result.quote==='object')err.quote=result.quote;throw err;}
    return result;
  }
  async function api(operation,payload) {
    if(!sessionToken) throw new Error('سجّل الدخول بكود واتساب الأول.');
    if(!['session','catalog','orders','quote','submit'].includes(operation)) throw new Error('طلب غير صالح.');
    const requestSessionToken=sessionToken;
    try { return await post(operation,{sessionToken:requestSessionToken,...(['quote','submit'].includes(operation)?{payload}:{})}); }
    catch(err) {if(err.code==='LOGIN_REQUIRED'&&sessionToken===requestSessionToken){sessionToken='';store.clear();root.hidden=false;root.dispatchEvent(new CustomEvent('wella:phone-logout',{bubbles:true}));}throw err;}
  }
  async function send() {
    const button=$('[data-send]');if(sending||Date.now()<nextSend)return;
    sending=true;button.disabled=true;
    try {
      phone=digits($('[name="phone"]').value.trim());
      const result=await post('send',{phone,browserKey});
      challengeId=result.challengeId; nextSend=Date.now()+result.retryAfter*1000;
      $('[data-code-step]').hidden=false;$('[name="code"]').value='';$('[name="code"]').focus();
      message(result.message);
    } catch(err){message(err.message||'تعذر إرسال الكود. حاول تاني.');}
    finally {sending=false;button.disabled=Date.now()<nextSend;}
  }
  $('[data-phone-form]').addEventListener('submit',event=>{event.preventDefault();send();});
  $('[data-code-form]').addEventListener('submit',async event=>{
    event.preventDefault();const button=$('[data-verify]');button.disabled=true;
    try {
      const code=digits($('[name="code"]').value.trim());
      const result=await post('verify',{phone,code,challengeId,browserKey});
      $('[name="code"]').value='';
      if(result.state==='approval_required') {sessionToken='';store.clear();message('الحساب محتاج موافقة الإدارة قبل ظهور أسعار الجملة.');return;}
      if(result.state!=='approved'||!result.sessionToken) throw new Error('تعذر التحقق من الحساب.');
      sessionToken=result.sessionToken;store.write(sessionToken);
      const session=await api('session');
      message('تم الدخول. جاري فتح موديلات الجملة.');
      root.dispatchEvent(new CustomEvent('wella:phone-login',{bubbles:true,detail:{session}}));
    } catch(err){message(err.message||'تعذر التحقق من الكود.');}
    finally {button.disabled=false;}
  });
  const timer=setInterval(()=>{
    if(!root.isConnected){clearInterval(timer);return;}
    const remaining=Math.max(0,Math.ceil((nextSend-Date.now())/1000));
    $('[data-send]').disabled=sending||remaining>0;
    $('[data-send]').textContent=remaining?`إعادة الإرسال بعد ${remaining} ثانية`:'إرسال كود واتساب';
  },1000);
  // The wholesale catalog's adapter consumes this API, never Shopify customer
  // cookies or a phone supplied in a product/cart request.
  window.wellaWholesalePhoneAuth=Object.freeze({api,
    // Called once by wella-wholesale.js on load: re-adopts a saved token (true = caller should start() and let session/catalog validate it).
    restore:()=>{if(sessionToken)return true;const saved=store.read();if(!saved)return false;sessionToken=saved;return true;},
    logout:async()=>{
      const token=sessionToken;sessionToken='';store.clear();                       // clear first: logout works even if the network call fails
      try {if(token)await post('logout',{sessionToken:token});}catch{/* the server session also expires on its own */}finally{location.reload();}
    }});
})();
